<template>
  <div>

    <!-- modal Edit-->
    <b-modal
      id="modal-edit-category"
      cancel-variant="outline-secondary"
      ok-title="Edit"
      cancel-title="Close"
      centered
      title="Edit Category"
      @ok="handleEdit"
    >
      <b-form>
        <b-form-group>
          <label for="id">Id:</label>
          <b-form-input
            id="id"
            type="number"
            placeholder="ID"
            v-model="category.id"
            readonly
          />
        </b-form-group>
        <b-form-group>
          <label for="name">Name:</label>
          <b-form-input
            type="text"
            v-model="category.name"
            placeholder="Name"
          />
        </b-form-group>
      </b-form>
    </b-modal>

    <b-modal
      id="modal-menu-category"
      scrollable
      title="Menu Category"
      cancel-title="Close"
      ok-title="OK"
      cancel-variant="outline-secondary"
    >
      <b-card no-body class="mb-0">
        <div class="m-2">
          <!-- Table Top -->
          <b-row>
            <!-- Search -->
            <b-col cols="12" md="12">
              <div class="d-flex align-items-center justify-content-end">
                <b-form-input
                  v-model="newCategory.name"
                  class="d-inline-block mr-1"
                  placeholder="New category..."
                />
                <b-button variant="primary" @click="addCategory">
                  <span class="text-nowrap">Add Category</span>
                </b-button>
              </div>
            </b-col>
          </b-row>
        </div>
        <b-table
          responsive="sm"
          :fields="categoryTableColumns"
          :items="categoryOptions"
        >
          <!-- Column: Actions -->
          <template #cell(actions)="data">
            <b-dropdown
              variant="link"
              no-caret
              :right="$store.state.appConfig.isRTL"
            >
              <template #button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="align-middle text-body"
                />
              </template>

              <b-dropdown-item @click="editCategory(data.item)">
                <feather-icon icon="EditIcon" />
                <span class="align-middle ml-50">Edit</span>
              </b-dropdown-item>

              <b-dropdown-item @click="confirmDelete(data.item.value)">
                <feather-icon icon="TrashIcon" />
                <span class="align-middle ml-50">Delete</span>
              </b-dropdown-item>
            </b-dropdown>
          </template>
        </b-table>
      </b-card>
    </b-modal>
  </div>
</template>

<script>
import { ref, onMounted } from "@vue/composition-api";
import store from "@/store";
import {
  BModal,
  BButton,
  BCard,
  BRow,
  BCol,
  BFormInput,
  BTable,
  BForm,
  BFormGroup,
  BDropdown,
  BDropdownItem,
} from "bootstrap-vue";
import useMenusList from "../menus-list/useMenusList";
export default {
  components: {
    BModal,
    BButton,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BTable,
    BDropdown,
    BDropdownItem,
    BForm,
    BFormGroup,
  },
  data() {
    return {
      newCategory: { id: 0, name: "" },
      category: { id: 0, name: "" },
    };
  },
  methods: {
    addCategory() {
      this.$swal({
        title: "Are you sure?",
        showCancelButton: true,
        confirmButtonText: "Yes, submit it!",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          if (this.newCategory.name.trim() != "") {
            store
              .dispatch("bar-menu/addMenuCategory", this.newCategory)
              .then((response) => {
                this.fetchMenuCategories();
                this.showMessage(
                  "Success",
                  response.data.message,
                  "CheckIcon",
                  "success"
                );
                this.newCategory = { id: 0, name: "" };
              })
              .catch((error) => {
                this.showMessage(
                  "Fail",
                  response.data.message,
                  "HeartIcon",
                  "danger"
                );
              });
          } else {
            this.showMessage(
              "Fail",
              "Please input new category",
              "HeartIcon",
              "danger"
            );
          }
        }
      });
    },
    editCategory(item) {
      this.category.id = item.value;
      this.category.name = item.label;
      this.$root.$emit("bv::show::modal", "modal-edit-category", "#btnShow");
    },
    handleEdit() {
      //updateMenuCategory
      store
        .dispatch("bar-menu/updateMenuCategory", this.category)
        .then((response) => {
          this.fetchMenuCategories();
          this.refetchData()
          this.showMessage(
            "Success",
            response.data.message,
            "CheckIcon",
            "success"
          );
          this.newCategory = { id: 0, name: "" };
        })
        .catch((error) => {
          this.showMessage(
            "Fail",
            response.data.message,
            "HeartIcon",
            "danger"
          );
        });
    },
    confirmDelete(id) {
        this.$swal({
        title: 'Are you sure?',
        text: "Your action is final and you are not able to recover the data.",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          store.dispatch('bar-menu/deleteMenuCategory', id)
          .then((response) => {
            this.fetchMenuCategories()
            this.refetchData()
            this.showMessage('Success', response.data.message, 'CheckIcon', 'success')
              
          }).catch( error => {
              console.log(error)
              this.showMessage('Fail', error.response.data.message, 'HeartIcon', 'danger')
          })
          
        }
      })
    },
  },
  props:{
    categoryOptions:{},
    categoryTableColumns:{},
  },
  setup(props, {emit}) {
    // const {
    //   categoryOptions,
    //   fetchMenuCategories, 
    //   categoryTableColumns,
    //   showMessage,
    // } = useMenusList();

    // onMounted(() => {
    //   fetchMenuCategories();
    // });
    const { showMessage } = useMenusList();
    
    const refetchData = () =>{
        emit('refetch-data')
    }
    const fetchMenuCategories = () =>{
        emit('fetch-menu-categories')
    }

    return {
      refetchData,
      fetchMenuCategories,
      showMessage
    };
  },
};
</script>

<style></style>
